
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"7","y":"7","width":"26","height":"26"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.082 20c0-7.131 5.784-12.917 12.917-12.917S32.915 12.87 32.915 20c0 7.135-5.783 12.917-12.916 12.917S7.082 27.135 7.082 20zM19.999 8.75c6.178 0 11.25 5.004 11.25 11.25 0 6.213-5.032 11.25-11.25 11.25-6.21 0-11.25-5.03-11.25-11.25 0-6.208 5.031-11.25 11.25-11.25zm-.434 14.375h.833c.346 0 .625-.28.625-.625v-.02c0-1.01.801-1.534 1.69-2.115 1.104-.722 2.344-1.532 2.344-3.479 0-2.628-2.35-4.178-5.075-4.178-2.335 0-3.647.913-4.752 2.33a.624.624 0 00.138.895l.684.477c.27.188.642.136.846-.124.778-.992 1.566-1.494 3.084-1.494 2.066 0 2.992 1.052 2.992 2.094 0 1.006-.785 1.5-1.662 2.052-1.112.7-2.372 1.494-2.372 3.542v.02c0 .345.28.625.625.625zm-1.025 2.708a1.458 1.458 0 112.917 0 1.458 1.458 0 01-2.917 0z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h40v40H0z"}})])])
          )
        }
      }
    